// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ia-0";
export var discountCodeInput = "_ia-1";